import React from 'react';
import { Layout as AntLayout, Button } from 'antd';
import { LogoutOutlined } from '@ant-design/icons';
import { colors } from '../theme';

const { Content } = AntLayout;

interface VendorLayoutProps {
  children: React.ReactNode;
  boothName?: string;
  onSignOut: () => void;
}

export function VendorLayout({ children, boothName: _boothName, onSignOut }: VendorLayoutProps) {
  return (
    <AntLayout style={{ minHeight: '100vh', background: colors.background }}>
      <Content
        style={{
          padding: '24px',
          maxWidth: 800,
          margin: '0 auto',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {children}

        <Button
          type="text"
          icon={<LogoutOutlined />}
          onClick={onSignOut}
          style={{
            marginTop: 'auto',
            paddingTop: 24,
            color: colors.textDescription,
          }}
        >
          Sair
        </Button>
      </Content>
    </AntLayout>
  );
}

export default VendorLayout;
